import onCopy from './handlers/onCopy';
import onCut from './handlers/onCut';
import onPaste from './handlers/onPaste';
export default function ClipboardPlugin() {
  return [{
    onCopy: onCopy,
    onCut: onCut,
    onPaste: onPaste
  }];
}